export default __webpack_public_path__ + "static/media/hht1_ep07_timeline_q03_a.88fed41d.png";